import Vue from 'vue'
import VueMixpanelBrowser from 'vue-mixpanel-browser'

Vue.use(VueMixpanelBrowser, {
  token: process.env.VUE_APP_MIX_PANEL_TOKEN,
})
